import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: ['Rubik', '"Helvetica Neue"'].join(','),
  },
  palette: {
    primary: {
      main: '#1E2F7B',
    },
  },
});

export default theme;
